import { Component, OnInit } from '@angular/core';
import { NgxQueryDynamicCustom } from 'zr-dynamic-form/dynamic-form-designer';

@Component({
  selector: 'df-ngx-query-dynamic-custom',
  templateUrl: './ngx-query-dynamic-custom.component.html',
  styleUrls: ['./ngx-query-dynamic-custom.component.css']
})
export class NgxQueryDynamicCustomComponent extends NgxQueryDynamicCustom implements OnInit {}
